var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-cbr-PageSection"},[(_vm.headline)?_c('h3',{staticClass:"c-cbr-PageSection-headline"},[_vm._v(_vm._s(_vm.headline))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d0c34fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ObjPageContainer.vue
// module id = 131
// module chunks = 0